import { createRoute } from '@tanstack/react-router';

import { useMaterialSearchStore } from '$/components/core/Collection/MaterialSearch/store/useMaterialSearchStore';
import { CollectionDashboard } from '$/pages/DashboardPages/pages/Collection';
import { BaseRouteLayout } from '$/routes/Layouts/BaseRouteLayout';
import { useCollectionStore } from '$/stores/useCollectionStore';

export const CollectionsRoute = createRoute({
  getParentRoute: () => BaseRouteLayout,
  path: '/collections',
  component: CollectionDashboard,
  loader: () => {
    useCollectionStore.setState({
      activeType: undefined,
      selectedViewMode: 'grid',
    });
    useMaterialSearchStore.setState({
      query: '',
      dropdownVisible: false,
    });
  },
  staleTime: 0,
});
